<app-dialog-header title="{{ selectedProvider.providerName + ' - ' + ('PAGE.CERTIFICATIONS.TITLE' | translate) }}" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <div class="content" [class.hidden]="(dataSource.loading$ | async) && !isFilterOrSearchActive">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-12">
            <app-search-outline [searchInput]="searchInput"></app-search-outline>

            <div class="header-actions" fxLayoutAlign="flex-start center">
                <mat-form-field class="mr-16 w-220 relative">
                    <mat-label>{{ 'PAGE.MODULE_FORM.TAB.CONTENT.PARTICIPANTS_PROGRESS.FILTER_BY_STATUS' | translate }}</mat-label>
                    <mat-select [formControl]="statusInput" multiple>
                        <mat-option *ngFor="let status of certificationProviderStatuses" [value]="status.value">{{ status.translationLabel | translate }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <app-flat-button [icon]="'add_circle'" [label]="'PAGE.CERTIFICATIONS.BUTTON.ADD'" (onClick)="openCertificationDialog()"></app-flat-button>
            </div>
        </div>

        <div class="w-100-p table-wrapper" [class.hidden]="(dataSource.loading$ | async) && isFilterOrSearchActive">
            <mat-table #table [dataSource]="dataSource">
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef>{{ 'PAGE.CERTIFICATIONS.TITLE' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let certification">
                        <p class="text-truncate" [class.opacity-50]="certification.status === CertificationProviderStatusEnum.Archived">
                            {{ certification.certificationName }}
                        </p>
                    </mat-cell>
                </ng-container>

                <!-- Validity Period Column -->
                <ng-container matColumnDef="validityPeriod">
                    <mat-header-cell *matHeaderCellDef>{{ 'GENERAL.PROPERTY.VALIDITY' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let certification">
                        <p class="text-truncate">{{ certification.validityPeriod ? certification.validityPeriod + ' ' + ('GENERAL.MONTHS' | translate) : '-' }}</p>
                    </mat-cell>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef>{{ 'GENERAL.PROPERTY.STATUS' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let certification">
                        <p class="text-truncate">
                            {{ certification.status | getStatusByValue: certificationProviderStatus:'translationLabel' | translate }}
                        </p>
                    </mat-cell>
                </ng-container>

                <!-- TargetCount Column -->
                <ng-container matColumnDef="targetCount">
                    <mat-header-cell *matHeaderCellDef>{{ 'PAGE.CERTIFICATIONS.LABEL.TARGET_CERTIFICATION_COUNT' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let certification">
                        <p class="text-truncate">
                            {{ certification.targetCount || '-' }}
                        </p>
                    </mat-cell>
                </ng-container>

                <!-- Buttons Column -->
                <ng-container matColumnDef="buttons">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let certification">
                        <div fxFlex="row" fxLayoutAlign="end center">
                            <button
                                mat-icon-button
                                [matMenuTriggerFor]="moreMenu"
                                aria-label="More"
                                (click)="$event.stopPropagation()"
                                *ngIf="certification.certificationName !== 'other'"
                            >
                                <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                            </button>

                            <mat-menu #moreMenu="matMenu" xPosition="before">
                                <button mat-menu-item aria-label="edit" (click)="openCertificationDialog(certification)">
                                    <mat-icon class="mr-8">edit</mat-icon>
                                    <span>{{ 'GENERAL.BUTTON.EDIT' | translate }}...</span>
                                </button>
                                <button mat-menu-item aria-label="edit" (click)="openMoveToDialog(certification)">
                                    <mat-icon class="mr-8">drive_file_move</mat-icon>
                                    <span>{{ 'GENERAL.BUTTON.MOVE' | translate }}...</span>
                                </button>
                                <button mat-menu-item aria-label="remove" (click)="updateCertificationStatus(certification)">
                                    <mat-icon class="mr-8" svgIcon="{{ certification.status ? 'reactivate' : 'archive' }}"></mat-icon>
                                    <span>{{ (certification.status ? 'GENERAL.BUTTON.REACTIVATE' : 'GENERAL.BUTTON.ARCHIVE') | translate }}...</span>
                                </button>
                            </mat-menu>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row
                    *matRowDef="let certification; columns: displayedColumns"
                    class="relative"
                    [class.pointer]="certification.certificationName !== 'other'"
                    matRipple
                    (click)="certification.certificationName !== 'other' ? openCertificationDialog(certification) : null"
                >
                </mat-row>
            </mat-table>
        </div>

        <div class="white" fxLayout="column" fxLayoutAlign="center center" *ngIf="(dataSource.loading$ | async) && isFilterOrSearchActive">
            <div class="p-80">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>

    <div
        class="shimmer-container p-0 mt-32"
        fxLayout="column"
        fxLayoutAlign="space-between flex-start"
        fxLayoutGap="16px"
        *ngIf="(dataSource.loading$ | async) && !isFilterOrSearchActive"
    >
        <div class="shimmer w-100-p mb-24" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="shimmer-title max-w-60 animate"></div>
            <div class="shimmer-title max-w-sm animate"></div>
        </div>
        <div class="shimmer w-100-p">
            <div class="shimmer-card module animate"></div>
        </div>
    </div>
</div>
